import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { SectionCard } from 'src/components/shared/SectionCard'

interface Props {
  message?: string
  dataTestId?: string
}

/** What a screen or section renders instead of its content when a permission is missing. */
const NoAccessCardComponent = ({
  message = "You don't have access to this page.",
  dataTestId = 'no-access-card',
}: Props) => {
  return (
    <SectionCard title="No access" dataTestId={dataTestId}>
      <Typography variant="body2" css={tw`text-shades-700`}>
        {message}
      </Typography>
    </SectionCard>
  )
}

export const NoAccessCard = memo(NoAccessCardComponent)
